var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("e-sidebar", {
    attrs: {
      id: "sidebar-auto-delivery-monitor-sale",
      title: _vm.saleId
        ? _vm.$t("Venda") +
          " #" +
          _vm.saleId +
          " - " +
          _vm.$t("Entrega automática")
        : "",
      show: !!_vm.saleId,
      fetching: _vm.fetching,
      "hide-save-button": true,
      "cancel-button-text": _vm.$t("Fechar"),
      "no-close-on-backdrop": false,
      width: "45%",
    },
    on: {
      hidden: function ($event) {
        return _vm.$emit("hidden")
      },
    },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _vm.detail
              ? _c(
                  "div",
                  [
                    _c("h3", { staticClass: "h5" }, [
                      _vm._v(" " + _vm._s(_vm.$t("Resumo")) + " "),
                    ]),
                    _c("dl", { staticClass: "monitor-detail__list" }, [
                      _c("dt", [_vm._v(_vm._s(_vm.$t("Loja")))]),
                      _c("dd", [
                        _vm._v(
                          _vm._s(_vm.sale.storeName || "#" + _vm.sale.storeId)
                        ),
                      ]),
                      _c("dt", [_vm._v(_vm._s(_vm.$t("Cliente")))]),
                      _c("dd", [
                        _vm._v(_vm._s(_vm.detail.customerName || "-")),
                      ]),
                      _c("dt", [_vm._v(_vm._s(_vm.$t("Valor")))]),
                      _c("dd", [
                        _vm._v(_vm._s(_vm.formatCurrency(_vm.detail.netValue))),
                      ]),
                      _c("dt", [_vm._v(_vm._s(_vm.$t("Criada em")))]),
                      _c("dd", [
                        _vm._v(
                          _vm._s(_vm.formatDateTime(_vm.sale.createdDate))
                        ),
                      ]),
                      _c("dt", [_vm._v(_vm._s(_vm.$t("Entrega prevista")))]),
                      _c("dd", [
                        _vm._v(
                          _vm._s(_vm.formatDateTime(_vm.detail.deliveryDate))
                        ),
                      ]),
                      _c("dt", [_vm._v(_vm._s(_vm.$t("Estado automático")))]),
                      _c(
                        "dd",
                        [
                          _c(
                            "b-badge",
                            {
                              attrs: {
                                variant: _vm.variant(
                                  _vm.autoDeliveryStateLabels,
                                  _vm.sale.autoDeliveryState
                                ),
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      _vm.label(
                                        _vm.autoDeliveryStateLabels,
                                        _vm.sale.autoDeliveryState
                                      )
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                          _vm.sale.ineligibilityReason
                            ? _c("span", [
                                _vm._v(
                                  " — " +
                                    _vm._s(
                                      _vm.$t(
                                        _vm.label(
                                          _vm.ineligibilityReasonLabels,
                                          _vm.sale.ineligibilityReason
                                        )
                                      )
                                    ) +
                                    " "
                                ),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c("dt", [_vm._v(_vm._s(_vm.$t("Entrega")))]),
                      _c("dd", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              _vm.label(
                                _vm.deliveryStatusLabels,
                                _vm.sale.deliveryStatus
                              )
                            )
                          )
                        ),
                      ]),
                      _c("dt", [_vm._v(_vm._s(_vm.$t("Motoboy próprio")))]),
                      _c("dd", [_vm._v(_vm._s(_vm.sale.motoboyName || "-"))]),
                      _vm.sale.alerts.length
                        ? _c("dt", [
                            _vm._v(" " + _vm._s(_vm.$t("Alertas")) + " "),
                          ])
                        : _vm._e(),
                      _vm.sale.alerts.length
                        ? _c(
                            "dd",
                            _vm._l(_vm.sale.alerts, function (alert) {
                              return _c(
                                "b-badge",
                                {
                                  key: alert,
                                  staticClass: "mr-25",
                                  attrs: { variant: "light-danger" },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          _vm.label(_vm.alertLabels, alert)
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              )
                            }),
                            1
                          )
                        : _vm._e(),
                    ]),
                    _c("h3", { staticClass: "h5 mt-2" }, [
                      _vm._v(" " + _vm._s(_vm.$t("Work")) + " "),
                    ]),
                    !_vm.detail.works.length
                      ? _c("p", { staticClass: "text-muted" }, [
                          _vm._v(" " + _vm._s(_vm.$t("Nenhum work.")) + " "),
                        ])
                      : _vm._e(),
                    _vm._l(_vm.detail.works, function (work) {
                      return _c(
                        "dl",
                        {
                          key: work.id,
                          staticClass:
                            "monitor-detail__list monitor-detail__block",
                        },
                        [
                          _c("dt", [_vm._v(_vm._s(_vm.$t("Geração")))]),
                          _c("dd", [_vm._v(_vm._s(work.generation))]),
                          _c("dt", [_vm._v(_vm._s(_vm.$t("Estado")))]),
                          _c(
                            "dd",
                            [
                              _c(
                                "b-badge",
                                {
                                  attrs: {
                                    variant: _vm.variant(
                                      _vm.workStateLabels,
                                      work.state
                                    ),
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          _vm.label(
                                            _vm.workStateLabels,
                                            work.state
                                          )
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c("dt", [_vm._v(_vm._s(_vm.$t("Disponível em")))]),
                          _c("dd", [
                            _vm._v(
                              _vm._s(_vm.formatDateTime(work.availableAt))
                            ),
                          ]),
                          _c("dt", [_vm._v(_vm._s(_vm.$t("Tentativas")))]),
                          _c("dd", [_vm._v(_vm._s(work.attemptCount))]),
                          _c("dt", [_vm._v(_vm._s(_vm.$t("Lease")))]),
                          _c("dd", [
                            _vm._v(
                              _vm._s(
                                work.leaseOwner
                                  ? work.leaseOwner +
                                      " até " +
                                      _vm.formatDateTime(work.leaseExpiresAt)
                                  : "-"
                              )
                            ),
                          ]),
                          _c("dt", [_vm._v(_vm._s(_vm.$t("Último erro")))]),
                          _c(
                            "dd",
                            { class: { "text-danger": work.lastErrorCode } },
                            [
                              _vm._v(
                                " " + _vm._s(work.lastErrorCode || "-") + " "
                              ),
                            ]
                          ),
                          _c("dt", [
                            _vm._v(_vm._s(_vm.$t("Criado / concluído"))),
                          ]),
                          _c("dd", [
                            _vm._v(
                              _vm._s(_vm.formatDateTime(work.createdDate)) +
                                " / " +
                                _vm._s(_vm.formatDateTime(work.completedAt))
                            ),
                          ]),
                        ]
                      )
                    }),
                    _c("h3", { staticClass: "h5 mt-2" }, [
                      _vm._v(
                        " " + _vm._s(_vm.$t("Fornecedores acionados")) + " "
                      ),
                    ]),
                    !_vm.sale.dispatches.length
                      ? _c("p", { staticClass: "text-muted" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("Nenhum fornecedor foi acionado.")
                              ) +
                              " "
                          ),
                        ])
                      : _vm._e(),
                    _vm._l(_vm.sale.dispatches, function (dispatch) {
                      return _c(
                        "dl",
                        {
                          key: dispatch.id,
                          staticClass:
                            "monitor-detail__list monitor-detail__block",
                          class: {
                            "monitor-detail__block--winner":
                              dispatch.isAccepted,
                          },
                        },
                        [
                          _c("dt", [_vm._v(_vm._s(_vm.$t("Fornecedor")))]),
                          _c(
                            "dd",
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    dispatch.deliverySupplierName ||
                                      "#" + dispatch.deliverySupplierId
                                  ) +
                                  " "
                              ),
                              dispatch.isAccepted
                                ? _c(
                                    "b-badge",
                                    {
                                      staticClass: "ml-25",
                                      attrs: { variant: "success" },
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(_vm.$t("Vencedor")) + " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c("dt", [_vm._v(_vm._s(_vm.$t("Execução")))]),
                          _c(
                            "dd",
                            [
                              _c(
                                "b-badge",
                                {
                                  attrs: {
                                    variant: _vm.variant(
                                      _vm.dispatchStateLabels,
                                      dispatch.executionState
                                    ),
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          _vm.label(
                                            _vm.dispatchStateLabels,
                                            dispatch.executionState
                                          )
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c("dt", [
                            _vm._v(_vm._s(_vm.$t("Status no fornecedor"))),
                          ]),
                          _c("dd", [
                            _vm._v(_vm._s(dispatch.supplierStatus || "-")),
                          ]),
                          _c("dt", [
                            _vm._v(_vm._s(_vm.$t("Pedido no fornecedor"))),
                          ]),
                          _c("dd", [
                            _vm._v(_vm._s(dispatch.supplierOrderId || "-")),
                          ]),
                          _c("dt", [_vm._v(_vm._s(_vm.$t("Tentativas")))]),
                          _c("dd", [
                            _vm._v(" " + _vm._s(dispatch.attemptCount) + " "),
                            dispatch.nextAttemptAt
                              ? _c("span", [
                                  _vm._v(
                                    " (" +
                                      _vm._s(_vm.$t("próxima")) +
                                      ": " +
                                      _vm._s(
                                        _vm.formatDateTime(
                                          dispatch.nextAttemptAt
                                        )
                                      ) +
                                      ") "
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                          _c("dt", [
                            _vm._v(_vm._s(_vm.$t("Solicitado / respondido"))),
                          ]),
                          _c("dd", [
                            _vm._v(
                              _vm._s(_vm.formatDateTime(dispatch.requestedAt)) +
                                " / " +
                                _vm._s(_vm.formatDateTime(dispatch.respondedAt))
                            ),
                          ]),
                          dispatch.failureReason || dispatch.lastErrorCode
                            ? _c("dt", [
                                _vm._v(" " + _vm._s(_vm.$t("Falha")) + " "),
                              ])
                            : _vm._e(),
                          dispatch.failureReason || dispatch.lastErrorCode
                            ? _c("dd", { staticClass: "text-danger" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      [
                                        dispatch.failureReason,
                                        dispatch.lastErrorCode,
                                      ]
                                        .filter(Boolean)
                                        .join(" · ")
                                    ) +
                                    " "
                                ),
                              ])
                            : _vm._e(),
                        ]
                      )
                    }),
                    _c("h3", { staticClass: "h5 mt-2" }, [
                      _vm._v(" " + _vm._s(_vm.$t("Linha do tempo")) + " "),
                    ]),
                    !_vm.detail.timeline.length
                      ? _c("p", { staticClass: "text-muted" }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("Nenhum evento registrado.")) +
                              " "
                          ),
                        ])
                      : _vm._e(),
                    _c(
                      "ul",
                      {
                        staticClass:
                          "monitor-detail__timeline list-unstyled mb-0",
                      },
                      _vm._l(_vm.detail.timeline, function (entry, index) {
                        return _c("li", { key: index }, [
                          _c("small", { staticClass: "text-muted" }, [
                            _vm._v(_vm._s(_vm.formatDateTime(entry.at))),
                          ]),
                          _c(
                            "strong",
                            { staticClass: "d-block" },
                            [
                              _vm._v(" " + _vm._s(entry.title) + " "),
                              entry.published === false
                                ? _c(
                                    "b-badge",
                                    {
                                      staticClass: "ml-25",
                                      attrs: { variant: "danger" },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("não publicado")) +
                                          " "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          entry.details
                            ? _c("small", { staticClass: "d-block" }, [
                                _vm._v(_vm._s(entry.details)),
                              ])
                            : _vm._e(),
                          entry.lastErrorCode
                            ? _c(
                                "small",
                                { staticClass: "d-block text-danger" },
                                [_vm._v(_vm._s(entry.lastErrorCode))]
                              )
                            : _vm._e(),
                        ])
                      }),
                      0
                    ),
                  ],
                  2
                )
              : _vm._e(),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }